import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

const main = {
  height: {
    iphone: 50,
  },
};

export const OptionListStyle = styled.div`
  border-radius: 8px;
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  position: relative;
  width: 100%;
  
  &.light-theme {
    background-color: ${colors.mostlyWhite};

    .option-item-button,
    .option-item-content {
      border: solid 1px ${colors.mostlyWhite};
      color: ${colors.veryDarkGrayishBlue};

      svg {
        fill: ${colors.veryDarkGrayishBlue};
      }
    }

    .option-item-button {
      &.active {
        background-color: ${colors.softBlue};
        border: solid 1px ${colors.softBlue};
      }
    }
  }

  &.dark-theme,
  &.default-theme {
    background-color: ${colors.veryDarkGrayishBlue};

    .option-item-button,
    .option-item-content {
      border: solid 1px ${colors.veryDarkGrayishBlue};
      color: ${colors.mostlyWhite};

      svg {
        fill: ${colors.mostlyWhite};
      }
    }

    .option-item-button {
      &.active {
        background-color: ${colors.softBlue};
        border: solid 1px ${colors.softBlue};
      }
    }
  }

  &.soft-blue-outline-theme {
    background-color: ${colors.white};
    color: ${colors.softBlue};

    .option-item-button,
    .option-item-content {
      border: solid 1px ${colors.softBlue};
      color: ${colors.softBlue};

      svg {
        fill: ${colors.softBlue};
      }
    }

    .option-item-button {
      &.active {
        background-color: ${colors.white};

        svg {
          fill: ${colors.white};
        }
      }
    }
  }

  &.grayish-blue-outline-theme {
    background-color: ${colors.white};

    .option-item-button,
    .option-item-content {
      border: solid 1px ${colors.grayishBlue};
      color: ${colors.grayishBlue};

      svg {
        fill: ${colors.grayishBlue};
      }
    }

    .option-item-button {
      &.active {
        background-color: ${colors.softBlue};
        border: solid 1px ${colors.softBlue};
        color: ${colors.white};

        svg {
          fill: ${colors.white};
        }
      }
    }
  }

  &.rounded-shape {
    border-radius: 8px;
  }

  &.circle-shape {
    border-radius: ${main.height.iphone / 2}px;
  }

  &.square-shape {
    border-radius: 0;
  }

  .option-item-button {
    background-color: transparent;
    display: block;
    min-width: ${main.height.iphone}px;
    padding: 12px;
    transition: background-color 300ms, border 300ms, color 300ms;
  }

  .option-item-content {
    ${fontFamily.sourceSansPro.regular};
    font-size: 13px;
    line-height: 26px;
    padding: 12px;
    text-align: center;
  }

  .option-item-button,
  .option-item-content {
    svg {
      display: block;
      height: auto;
      margin: 0 auto;
      max-height: 20px;
      max-width: 20px;
      transition: fill 300ms;
      width: auto;
    }
  }
`;
